.emptyPlaceholder {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 100;
  height: 100%;
  text-align: center;
  font-size: 2rem;
  color: var(--color-secondary);
  padding: calc(var(--gap-regular) * 2);
}
